/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Err_Privacy_RequiredInputs */

const es_footer_err_privacy_required = /** @type {(inputs: Footer_Err_Privacy_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debes aceptar la política de privacidad para continuar.`)
};

const gl_footer_err_privacy_required = /** @type {(inputs: Footer_Err_Privacy_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debes aceptar a política de privacidade para continuar.`)
};

const en_footer_err_privacy_required = /** @type {(inputs: Footer_Err_Privacy_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must accept the privacy policy to continue.`)
};

/**
* | output |
* | --- |
* | "You must accept the privacy policy to continue." |
*
* @param {Footer_Err_Privacy_RequiredInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_err_privacy_required = /** @type {((inputs?: Footer_Err_Privacy_RequiredInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Err_Privacy_RequiredInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_err_privacy_required(inputs)
	if (locale === "en") return en_footer_err_privacy_required(inputs)
	return es_footer_err_privacy_required(inputs)
});